module.exports = __webpack_public_path__ + "public/adminIcons/staticContent.svg?7069bfe0";